import { useSelector } from 'react-redux';
import UserAvatar from './UserAvatar';
import UserInfo from './UserInfo';
import UserProfileTabs from './UserProfileTabs';
import { User, UserProfileTab } from './types';
import './UserProfileHeader.scss';

type props = {
  userProfileDetails: User;
  onUpdateUserDetails: (updatedDetails: User) => void;
  selectedTab: string;
  userTabs: UserProfileTab[];
};

export default function UserProfileHeader({
  userProfileDetails,
  onUpdateUserDetails,
  selectedTab,
  userTabs,
}: props) {
  const { loggedInUser } = useSelector(
    ({ authentication }: any) => authentication,
  );

  return (
    <>
      {userProfileDetails && (
        <div className="user-profile-photo-section bg-white">
          <div className="user-content">
            <UserAvatar userProfileDetails={userProfileDetails} />
            <div className="user-details">
              <UserInfo
                userProfileDetails={userProfileDetails}
                onUpdateUserDetails={onUpdateUserDetails}
              />
              {loggedInUser?.id && (
                <UserProfileTabs
                  userProfileDetails={userProfileDetails}
                  profileTabs={userTabs}
                  selectedTab={selectedTab}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
